import { Navigate } from "react-router-dom";
import { getAuthToken, getAuthRole } from "./authHelpers";

const OnboardingGuard = ({ children }) => {
  const token = getAuthToken();
  const role = getAuthRole();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (role && role !== "Client" && role !== "Admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default OnboardingGuard;
